module.exports = __webpack_public_path__ + "static/media/cdphp-usnews-medicare-2025.708b6e75.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cdphp-usnews-medicare-2025.svg
// module id = 234
// module chunks = 0